import { _ as e } from "../_rollupPluginBabelHelpers-d2f9cf82.js";
import { useState as t, useEffect as n } from "react";
var r = function () {
  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [{
      name: "mobile",
      maxWidth: 480
    }, {
      name: "tablet",
      maxWidth: 768
    }, {
      name: "desktop",
      maxWidth: 1024
    }],
    i = t("desktop"),
    o = e(i, 2),
    a = o[0],
    d = o[1];
  return n(function () {
    var e = function () {
      for (var e = window.innerWidth, t = 0; t < r.length; t++) if (e <= r[t].maxWidth) return void d(r[t].name);
      d("desktop");
    };
    return e(), window.addEventListener("resize", e), function () {
      window.removeEventListener("resize", e);
    };
  }, [r]), a;
};
export { r as default };